import { useEffect, useState } from 'react'

/**
 * Returns the current hostname from window.location.hostname.
 * Returns null during SSR or before client hydration.
 */
const useHostname = (): string | null => {
  const [hostname, setHostname] = useState<string | null>(null)

  useEffect(() => {
    setHostname(typeof window !== 'undefined' ? window.location.hostname : null)
  }, [])

  return hostname
}

export default useHostname
